import React, { useContext, useEffect, useState } from "react";
import { Bars } from "react-loader-spinner";
import {
  getStateZipCodesData,
  getGeoLocationData,
  markerData,
  getQuarterFromDate,
} from "../Helpers/helpers";

// @ts-ignore
import { v4 as uuidv4 } from "uuid";
import { authContext } from "../Context/Authentication/authContext";
import Map from "./Components/Map/Map";
import LayersComponent from "./Components/Map/layers";
import axios from "axios";
import { baseURL } from "../config";

const HeatMap = (props: any) => {
  const { displayedRecords } = props;
  const { state, dispatch }: any = useContext(authContext);
  const [stateData, setStateData]: any = useState([]);
  const [geoData, setGeoData] = useState<any>({});
  const [isLoading, setLoading] = useState(true);
  const [selectedState, setSelectedState] = useState(null);
  const [markersData, setMarkersData] = useState([]);
  const [profitableExpectedReturn, setProfitableExpectedReturn] = useState([]);
  const [profitablePpsfGrowthReturn, setProfitablePpsfGrowthReturn] = useState(
    []
  );
  const [profitableHomeSalesReturn, setProfitableHomeSalesReturn] = useState(
    []
  );
  const [profitableDaysOnMarketReturn, setProfitableDaysOnMarketReturn] =
    useState([]);
  const [selectedMonth, setSelectedMonth] = useState("24");
  const [selectedMiles, setSelectedMiles] = useState("300 Mile");
  const [selectedTopRecords, setSelectedTopRecords] =
    useState(displayedRecords);
  const [selectedQuarter, setSelectedQuarter] = useState("2023-Q1");
  const [schoolData, setSchoolData] = useState<any>([]);
  const [hurricaneData, setHurricaneData] = useState<any>([]);
  const [showHeatMap, setShowHeatMap] = useState<boolean>(
    state.filters.showHeatMap
  );

  useEffect(() => {
    if (state.filters.showSchoolMap) {
      handleLayer("School District");
    }
  }, [state.filters.schoolRating, state.filters.schoolType]);

  useEffect(() => {
    const selectMonth = state.filters.heatMapMonths;
    const selectTopRecords = state.filters.heatmapTopRecords;
    const selectMiles = state.filters.heatMapMiles;
    const selectedTerritory = state.filters.selectedTerritory;
    if (
      selectedState !== selectedTerritory ||
      selectMonth !== selectedMonth ||
      selectTopRecords !== selectedTopRecords ||
      selectMiles !== selectedMiles
    ) {
      setSelectedMonth(selectMonth);
      setSelectedMiles(selectMiles);
      setSelectedState(selectedTerritory);
      setSelectedTopRecords(selectTopRecords);
      setLoading(true);
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          stateLoading: true,
        },
      });
      loadData(true);

      const predictionTillData =
        state.filters.predictionTill[selectedTerritory.toLowerCase()];
      if (predictionTillData && predictionTillData.zip) {
        setSelectedQuarter(getQuarterFromDate(predictionTillData.zip));
      }
    }
  });

  const loadData = async (isLoad: boolean) => {
    if (isLoad || isLoading) {
      await getStateHeatMapData();
    }
  };

  const getStateHeatMapData = async () => {
    try {
      const selectedTerritory = state.filters.selectedTerritory;
      const selectedProfitability =
        state.filters.profitability || "All Zipcodes";
      const selectMonth = state.filters.heatMapMonths;
      const radius = state.filters.heatMapMiles
        .split(" ")
        .join("_")
        .toLowerCase();

      const {
        data,
        profitableExpectedData,
        profitablePpsfGrowthData,
        profitableHomeSalesData,
        profitableDaysOnMarketData,
        totalCount,
      } = await getStateZipCodesData(selectedTerritory, selectMonth, radius);
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          totalHeatmapRecords: totalCount,
        },
      });
      setStateData(data);
      // @ts-ignore
      setProfitableExpectedReturn(profitableExpectedData);
      // @ts-ignore
      setProfitablePpsfGrowthReturn(profitablePpsfGrowthData);
      // @ts-ignore
      setProfitableHomeSalesReturn(profitableHomeSalesData);
      // @ts-ignore
      setProfitableDaysOnMarketReturn(profitableDaysOnMarketData);
      const markersDataInfo = markerData(data);
      // @ts-ignore
      setMarkersData(markersDataInfo);

      let allData: any = [];
      if (selectedProfitability === "All Zipcodes") {
        allData = data;
      } else {
        const cube = await getStateZipCodesData(
          selectedTerritory,
          selectMonth,
          radius
        );
        allData = cube.data;
      }
      // @ts-ignore

      const key = selectedTerritory.toLowerCase();
      let geoLocationInfo = await getGeoJSONInfo(key);
      // @ts-ignore
      setGeoData(geoLocationInfo);
      setLoading(false);
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          stateLoading: false,
        },
      });
    } catch (error) {
      console.log("error", error);
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          stateLoading: false,
        },
      });
    }
  };

  const getGeoJSONInfo = async (key: string) => {
    let resp;
    let data = {};
    resp = await fetch(`../fullgeoJsonData/${key}.json`);
    data = await resp.json();

    // if (key === 'florida') {
    // resp = await fetch('../geoJsonData/florida.json')
    // data = await resp.json()
    // } else if (key === 'california') {
    //   resp = await fetch('../geoJsonData/california.json')
    //   data = await resp.json()
    // } else if (key === 'tennessee') {
    //   resp = await fetch('../geoJsonData/tennessee.json')
    //   data = await resp.json()
    // } else if (key === 'texas') {
    //   resp = await fetch('../geoJsonData/texas.json')
    //   data = await resp.json()
    // } else if (key === 'arizona') {
    //   resp = await fetch('../geoJsonData/arizona.json')
    //   data = await resp.json()
    // }
    // else if (key === 'indiana') {
    //   resp = await fetch('../geoJsonData/indiana.json')
    //   data = await resp.json()
    // }
    // else if (key === 'north carolina') {
    //   resp = await fetch('../geoJsonData/north carolina.json')
    //   data = await resp.json()
    // }
    // else if (key === 'south carolina') {
    //   resp = await fetch('../geoJsonData/south carolina.json')
    //   data = await resp.json()
    // }
    // else if (key === 'georgia') {
    //   resp = await fetch('../geoJsonData/georgia.json')
    //   data = await resp.json()
    // }
    // else if (key === 'illinois') {
    //   resp = await fetch('../geoJsonData/illinois.json')
    //   data = await resp.json()
    // }
    // else if (key === 'idaho') {
    //   resp = await fetch('../geoJsonData/idaho.json')
    //   data = await resp.json()
    // }
    // else if (key === 'minnesota') {
    //   resp = await fetch('../geoJsonData/minnesota.json')
    //   data = await resp.json()
    // }
    // else if (key === 'utah') {
    //   resp = await fetch('../geoJsonData/utah.json')
    //   data = await resp.json()
    // }
    // else if (key === 'colorado') {
    //   resp = await fetch('../geoJsonData/colorado.json')
    //   data = await resp.json()
    // }
    // else if (key === 'washington') {
    //   resp = await fetch('../geoJsonData/washington.json')
    //   data = await resp.json()
    // }
    // else if (key === 'oregon') {
    //   resp = await fetch('../geoJsonData/oregon.json')
    //   data = await resp.json()
    // }
    // else if (key === 'virginia') {
    //   resp = await fetch('../geoJsonData/virginia.json')
    //   data = await resp.json()
    // }
    // else if (key === 'wisconsin') {
    //   resp = await fetch('../geoJsonData/wisconsin.json')
    //   data = await resp.json()
    // }
    // else if (key === 'alabama') {
    //   resp = await fetch('../geoJsonData/alabama.json')
    //   data = await resp.json()
    // }
    // else if (key === 'alabama') {
    //   resp = await fetch('../geoJsonData/alabama.json')
    //   data = await resp.json()
    // }

    return data;
  };
  const handleLayer = (text: any) => {
    if (text === "Flood") {
      setShowHeatMap(false);
      setSchoolData([]);
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          showFloodMap: true,
          showFireMap: false,
          showSchoolMap: false,
          showHeatMap: false,
          showHurricaneMap: false,
        },
      });
    } else if (text === "Fire") {
      setShowHeatMap(false);
      setSchoolData([]);
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          showFloodMap: false,
          showFireMap: true,
          showSchoolMap: false,
          showHeatMap: false,
          showHurricaneMap: false,
        },
      });
    } else if (text === "School District") {
      setLoading(true);
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          stateLoading: true,
        },
      });
      setShowHeatMap(false);
      axios
        .get(
          `${baseURL}getPublicSchoolsData?state=${
            state.filters.selectedTerritory
          }&ispublic=${
            state.filters.schoolType == "Public" ? true : false
          }&ratingband=${
            state.filters.schoolType == "Public"
              ? state.filters.schoolRating === "All"
                ? ""
                : state.filters.schoolRating
              : ""
          }`
        )
        .then((response) => {
          setLoading(false);
          const dataArray = response.data.cube; // Assuming this is an array of objects
          setSchoolData(dataArray);
          // Set layer loading to false after API call success
        })
        .catch((error) => {
          console.error("Error calling API:", error);
          setLoading(false);
          dispatch({
            type: "APPLY_FILTER",
            payload: {
              ...state.filters,
              stateLoading: false,
            },
          });
          // Set layer loading to false even if the API call fails
        });
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          showFloodMap: false,
          stateLoading: false,
          showFireMap: false,
          showHeatMap: false,
          showHurricaneMap: false,
          showSchoolMap: true,
        },
      });
    } else if (text === "Hurricane") {
      setLoading(true);
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          stateLoading: true,
        },
      });
      setShowHeatMap(false);
      setSchoolData([]);
      axios
        .get(
          `${baseURL}getHurricaneData?state=${state.filters.selectedTerritory}`
        )
        .then((response) => {
          setLoading(false);
          var dataArray = response.data.cube;
          dataArray = dataArray.map((item: any) => {
            if (item.zipcode.length === 4) {
              item.zipcode = `0${item.zipcode}`;
            }
            return item;
          });
          const zipCodesSet = new Set(dataArray.map((obj: any) => obj.zipcode));

          const matchingData = Object.keys(geoData)
            .filter((zipCode) => zipCodesSet.has(zipCode)) // Find matching zip codes
            .map((zipCode) => {
              // Find corresponding data in arrayOfObjects
              const disasterData = dataArray.find(
                (obj: any) => obj.zipcode === zipCode.toString()
              );
              // Add county, disasterPred, and disasterType to the properties of the matching dataObject
              if (disasterData) {
                geoData[zipCode].properties.county = disasterData.county;
                geoData[zipCode].properties.disasterPred =
                  disasterData.disasterPred;
                geoData[zipCode].properties.disasterType =
                  disasterData.disasterType;
              }

              // Return the updated dataObject for the matching zip code
              return geoData[zipCode];
            });

          setHurricaneData(matchingData);
          // Step 3: Console the matching data
        })
        .catch((error) => {
          console.error("Error calling API:", error);
          setLoading(false);
          dispatch({
            type: "APPLY_FILTER",
            payload: {
              ...state.filters,
              stateLoading: false,
            },
          });
          // Set layer loading to false even if the API call fails
        });
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          showFloodMap: false,
          showFireMap: false,
          showHeatMap: false,
          showSchoolMap: false,
          showHurricaneMap: true,
          stateLoading: false,
        },
      });
    } else {
      setShowHeatMap(true);
      setSchoolData([]);
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...state.filters,
          showFloodMap: false,
          showFireMap: false,
          showSchoolMap: false,
          showHurricaneMap: false,
          showHeatMap: true,
        },
      });
    }
  };

  const handleLayerLoading = (bool: any) => {
    setLoading(bool);
    dispatch({
      type: "APPLY_FILTER",
      payload: {
        ...state.filters,
        stateLoading: bool,
      },
    });
  };

  return (
    <div className="heatmap-main">
      <div className="heatmap-main__map-container">
        {isLoading ? (
          <Map
            chartData={stateData}
            geoData={geoData}
            profitability={state.filters.profitability}
            markers={markersData}
            showMarkers={state.filters.showMarkers}
            key={uuidv4()}
            profitableExpectedReturn={profitableExpectedReturn}
            profitablePpsfGrowthReturn={profitablePpsfGrowthReturn}
            profitableHomeSalesReturn={profitableHomeSalesReturn}
            profitableDaysOnMarketReturn={profitableDaysOnMarketReturn}
            heatmapTopRecords={selectedTopRecords}
            selectedQuarter={selectedQuarter}
            selectedMonth={selectedMonth}
            loading={isLoading}
            layerLoading={handleLayerLoading}
            dialog={props.dialog}
            schoolData={schoolData}
          />
        ) : (
          <Map
            chartData={stateData}
            geoData={geoData}
            profitability={state.filters.profitability}
            markers={markersData}
            showMarkers={state.filters.showMarkers}
            showFloodMap={state.filters.showFloodMap}
            key={uuidv4()}
            profitableExpectedReturn={profitableExpectedReturn}
            profitablePpsfGrowthReturn={profitablePpsfGrowthReturn}
            profitableHomeSalesReturn={profitableHomeSalesReturn}
            profitableDaysOnMarketReturn={profitableDaysOnMarketReturn}
            heatmapTopRecords={selectedTopRecords}
            selectedQuarter={selectedQuarter}
            selectedMonth={selectedMonth}
            loading={isLoading}
            layerLoading={handleLayerLoading}
            schoolData={schoolData}
            hurricaneData={hurricaneData}
            showHeatMap={showHeatMap}
            dialog={props.dialog}
          />
        )}
        {
          !state.filters.stateLoading && (
            <div id="sliderContainer">
          <LayersComponent
            handleLayer={handleLayer}
            dialog={props.dialog}
            schoolData={schoolData}
          />
        </div>
          )
        }
      </div>
    </div>
  );
};

export default HeatMap;
